import React from 'react'
import PropTypes from 'prop-types'

const RedBtn = ({ title, action, icon }) => (

  <button type='button' className='btn btn-danger' onClick={action}>
    {icon ? <i className={icon} /> : ''}
    <span className='text-center'>{title}</span>
  </button>
)

RedBtn.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  action: PropTypes.func.isRequired
}

export default RedBtn



// WEBPACK FOOTER //
// ./src/molecules/components/RedBtn.js